import { useMemo } from "react";

/**
 * @param {Array} tableData
 * @param {string} searchTerm
 * @param {Object} filters
 * @param {Array} columns
 */
export function useFilteredData(
  tableData,
  searchTerm,
  filters = {},
  columns = [],
) {
  const filteredData = useMemo(() => {
    return (tableData || []).filter((item) => {
      const searchMatch =
        !searchTerm ||
        columns.some((col) =>
          String(item[col.accessorKey] || "")
            .toLowerCase()
            .includes(searchTerm.toLowerCase()),
        );

      const filtersMatch = Object.entries(filters).every(([key, value]) => {
        if (!value) return true;
        return String(item[key] || "")
          .toLowerCase()
          .includes(value.toLowerCase());
      });

      return searchMatch && filtersMatch;
    });
  }, [tableData, searchTerm, filters, columns]);

  return filteredData;
}
